import React, { Component } from "react"
import Layout from "../../shared/components/organisms/layout/layout"
import SEO from "../../shared/seo"
// import {graphql} from 'gatsby'
import LegalContent from "../organisms/legal-content/legal-content"

export class LegalTemplate extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mobile: false,
      isLog: false,
    }
  }

  componentDidMount() {
    if (window.innerWidth < 1024) {
      this.setState({
        mobile: true,
      })
    }
    window.addEventListener("resize", this.updateDimensions)
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions)
  }

  handleScroll = event => {
    // do something like call `this.setState`
    // access window.scrollY etc
    this.setState({ scrollValue: window.scrollY })
  }

  updateDimensions = () => {
    if (window.innerWidth < 1024) {
      this.setState({
        mobile: true,
      })
    } else {
      this.setState({
        mobile: false,
      })
    }
  }

  render() {
    return (
      <Layout title={this.props.pageContext.metaTitulo} mobile={this.state.mobile} modalActive={this.state.modalActive}>
        <SEO
          title={this.props.pageContext.metaTitulo}
          description={this.props.pageContext.metaDescripcion.metaDescripcion}
          url={"/" + this.props.pageContext.slug}
        />

        <LegalContent info={this.props.pageContext} />
      </Layout>
    )
  }
}

export default LegalTemplate
